import { render } from "./GroupingTableHead.vue?vue&type=template&id=d0cc3ae0"
import script from "./GroupingTableHead.vue?vue&type=script&lang=ts"
export * from "./GroupingTableHead.vue?vue&type=script&lang=ts"
script.render = render

export default script